import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialogCloseEvent } from '../../../const';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html'
})
export class ConfirmComponent implements OnInit {
  message: string = "";
  status: boolean = false;
  constructor(private dialogRef: MatDialogRef<ConfirmComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) {  }

  ngOnInit(): void {
    this.message = this.data.message;
    this.status = this.data.status;  
  }
  
  confirm(){
    this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
  }

  cancel(){
    this.dialogRef.close({event:MatDialogCloseEvent.CANCELLED});
  }

}
